import React from "react"
import SEO from "../components/SEO"

const RefundPolicy: React.FC = () => {
  return (
    <>
      <SEO
        title="Refund Policy"
        description="Read Thecodebazaar.com's refund policy for digital products, themes, and services."
      />

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold text-gray-900 text-center">
            Refund Policy
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm">
          <p className="text-gray-600 mb-8">
            Last updated: January 2025
          </p>

          <div className="prose max-w-none space-y-8">
            {/* 1 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                1. Overview
              </h2>
              <p className="text-gray-700">
                At <strong>Thecodebazaar.com</strong>, we primarily sell digital
                products such as website themes, templates, UI components,
                source code, courses, and also provide custom development and
                digital services. Due to the nature of our offerings, our refund
                policy is strict and transparent.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                2. Digital Products (Themes, Templates, Courses)
              </h2>
              <p className="text-gray-700">
                All digital product purchases are <strong>non-refundable</strong>.
                This includes but is not limited to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>Website themes and templates</li>
                <li>Source code and UI components</li>
                <li>Courses, tutorials, or downloadable resources</li>
              </ul>
              <p className="text-gray-700 mt-3">
                Once a digital product is delivered or downloaded, we do not
                offer refunds, exchanges, or cancellations under any
                circumstances.
              </p>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                3. Services & Custom Work
              </h2>
              <p className="text-gray-700">
                For services such as website development, customization, or
                digital marketing:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>Advance payments are generally <strong>non-refundable</strong></li>
                <li>If work has already started, no refund will be issued</li>
                <li>If a client cancels the project after assigning work, the advance will not be refunded</li>
              </ul>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                4. Service Non-Delivery Exception
              </h2>
              <p className="text-gray-700">
                A refund may be considered <strong>only if</strong>:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>The client has paid an advance for a service</li>
                <li>Thecodebazaar.com fails to deliver the agreed service</li>
                <li>The refund request is made within <strong>30 days</strong> of payment</li>
              </ul>
              <p className="text-gray-700 mt-3">
                In such cases, refunds will be processed after internal review
                and approval.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Partial & Special Condition Refunds
              </h2>
              <p className="text-gray-700">
                In rare and exceptional cases, we may issue a partial refund.
                However:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>Work completed cost will be deducted</li>
                <li>Time, effort, and resources spent will be calculated</li>
                <li>The final refund amount will be decided solely by Thecodebazaar.com</li>
              </ul>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                6. No Refund Scenarios
              </h2>
              <p className="text-gray-700">
                Refunds will <strong>not</strong> be provided if:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-3">
                <li>You change your mind after purchase</li>
                <li>You no longer require the product or service</li>
                <li>Project requirements change after work has started</li>
                <li>Delay occurs due to client-side issues or lack of communication</li>
              </ul>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                7. Payment Processing Time
              </h2>
              <p className="text-gray-700">
                If a refund is approved, it will be processed within 7–14
                business days. The credited amount may take additional time
                depending on the payment method or bank.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                8. Legal Jurisdiction
              </h2>
              <p className="text-gray-700">
                This Refund Policy shall be governed by the laws of India. Any
                disputes shall fall under the jurisdiction of courts located in
                Madhya Pradesh, India.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                9. Contact Information
              </h2>
              <p className="text-gray-700">
                If you have any questions regarding this Refund Policy, please
                contact us through the official support channels available on
                Thecodebazaar.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

export default RefundPolicy